export const projectUtil = {
  generateProjectItemTreeData: (projectItems, filterItems) => {
    for (var i = 0; i < projectItems.length; i++) {
      var tempItem = projectItems[i]
      tempItem.level = 0
      while (tempItem.parentItem) {
        projectItems[i].level += 1
        tempItem = tempItem.parentItem
      }
    }
    projectItems.sort(function (item1, item2) {
      return item1.level - item2.level
    })
    var tempList = []
    for (var k = 0; k < projectItems.length; k++) {
      if (projectItems[k].parentItem == null) {
        projectItems[k].majorMaterials = []
        tempList.push(projectItems[k])
        tempList.sort(function (item1, item2) {
          return item1.id - item2.id
        })
      } else {
        var findParentItem = function (id, list) {
          for (var l = 0; l < list.length; l++) {
            if (list[l].id === id) {
              return list[l]
            }
            if (list[l].children) {
              var parentItem = findParentItem(id, list[l].children)
              if (parentItem != null) {
                return parentItem
              }
            }
          }
          return null
        }
        var parentItem = findParentItem(projectItems[k].parentItem.id, tempList)
        if (parentItem) {
          if (!parentItem.children) {
            parentItem.children = []
          }
          projectItems[k].majorMaterials = []
          parentItem.children.push(projectItems[k])
          parentItem.children.sort(function (item1, item2) {
            return item1.id - item2.id
          })
        }
      }
    }

    if (filterItems) {
      var filterList = function (item) {
        if (item.children && item.children.length > 0) {
          for (var k = item.children.length - 1; k >= 0; k--) {
            if (item.children[k].children && item.children[k].children.length > 0) {
              filterList(item.children[k])
              if (item.children[k].children.length === 0) {
                item.children.splice(k, 1)
              }
            } else {
              var find = false
              for (var l = 0; l < filterItems.length; l++) {
                if (parseInt(filterItems[l]) === item.children[k].id) {
                  find = true
                  break
                }
              }
              if (!find) {
                item.children.splice(k, 1)
              }
            }
          }
        }
      }

      for (var j = tempList.length - 1; j >= 0; j--) {
        filterList(tempList[j])
        if (!tempList[j].children || tempList[j].children.length === 0) {
          var find = false
          for (var l = 0; l < filterItems.length; l++) {
            if (parseInt(filterItems[l]) === tempList[j].id) {
              find = true
            }
          }
          if (!find) {
            tempList.splice(j, 1)
          }
        }
      }
    }

    return tempList
  },

  getProjectItemById (id, list) {
    id = parseInt(id)
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === id) {
        return list[i]
      } else if (list[i].children) {
        var result = this.getProjectItemById(id, list[i].children)
        if (result !== false) {
          return result
        }
      }
    }
    return false
  },

  listAllLeafItem (list) {
    var leafItems = []
    if (list && list.length) {
      for (var i = 0; i < list.length; i++) {
        if (!list[i].children || list[i].children.length === 0) {
          leafItems.push(list[i])
        } else {
          leafItems = leafItems.concat(this.listAllLeafItem(list[i].children))
        }
      }
    } else {
      return this.listAllLeafItem(list.children)
    }
    return leafItems
  },

  calcTotalCost (dataList, overgroundArea, undergroundArea) {
    var totalArea = Number(overgroundArea) + Number(undergroundArea)
    var totalCost = 0
    for (var i = 0; i < dataList.length; i++) {
      var itemData = dataList[i]
      if (itemData.children && itemData.children.length > 0) {
        totalCost += this.calcTotalCost(itemData.children, overgroundArea, undergroundArea)
      } else {
        if (itemData.cost !== undefined && itemData.cost !== '') {
          var areaType = this.getProjectItemAreaType(itemData)
          var area = totalArea
          if (areaType === 1) {
            area = overgroundArea
          } else if (areaType === 2) {
            area = undergroundArea
          }
          totalCost += Number(itemData.cost) * (itemData.parentItem ? Number(area) : 1)
        }
      }
    }
    return totalCost
  },

  getProjectItemAreaType (item) {
    if (item.name === '地上部分') {
      return 1
    } else if (item.name === '地下部分') {
      return 2
    }
    if (item.parentItem) {
      return this.getProjectItemAreaType(item.parentItem)
    }
    return 0
  },

  allCostEntered (dataList) {
    var costList = []
    for (var i = 0; i < dataList.length; i++) {
      var itemData = dataList[i]
      if (itemData.children && itemData.children.length > 0) {
        var result = this.allCostEntered(itemData.children)
        if (result === false) {
          return false
        }
        costList = costList.concat(result)
      } else {
        if (itemData.cost === undefined || itemData.cost === '') {
          return false
        } else {
          costList = costList.concat(itemData.id + ':' + itemData.cost)
        }
      }
    }
    return costList
  }
}

export const Utils = {
  deepClone (obj) {
    if (typeof obj !== 'object') {
      return obj
    }
    var newObj = obj instanceof Array ? [] : {}
    for (var key in obj) {
      newObj[key] = this.deepClone(obj[key])
    }
    return newObj
  },

  formatNum (num) {
    var numVal = num || 0
    var beforeNum = numVal.toString().split('.')[0]// 获取小数点之前的数字
    var afterNum = numVal.toString().split('.')[1]// 获取小数点之后的数字

    var beforeStr = beforeNum.replace(new RegExp('\\B(?=(\\d{3})+\\b)', 'g'), ',')
    var wholeStr = beforeStr
    if (afterNum) {
      wholeStr = beforeStr + '.' + afterNum
    }
    return wholeStr
  }
}
